import { EditorState, SelectionState, RichUtils } from 'draft-js';
import {
	getDeletingTableBlock,
	removeBlock,
	ensureHasBlock,
	getSelectedBlock,
	setSelectionToBlock,
} from 'lib/helpers';
import { InsertTableButton } from './InsertTableButton';
import { TableBlock } from './TableBlock';
import { createToolbarButtons } from '../createToolbarButtons';
import { createTableBlockProps } from './createTableBlockProps';


const defaultOptions = {
	buttons: ['table'],
};

const BUTTON_MAP = {
	table: InsertTableButton,
};

/**
 * @returns {DraftEditorPlugin}
 */
export function createTablePlugin(options = defaultOptions) {
	const { buttons } = { ...defaultOptions, ...options };
	const tableComponentMap = {};

	return {
		name: 'table',

		getToolbarButtons(props) {
			const { env, store } = props;
			// 宿主编辑环境
			if (env === 'root') {
				const editorState = props.store.getEditorState();
				// 代码块不支持插入表格
				if (RichUtils.getCurrentBlockType(editorState) === 'code-block') {
					return null;
				}
				return createToolbarButtons(BUTTON_MAP, buttons, {
					...props,
					focusTable: (key) => {
						if (tableComponentMap[key]) {
							tableComponentMap[key].focusFirstRow();
						}
					}
				});
			}
			// 表格编辑环境
			if (env === 'table' || env === 'table-multi-select') {
				return store.getTableToolbarButtons(props);
			}
			return null;
		},

		handleCommand(store, command, evt) {
			const editorState = store.getEditorState();
			const content = editorState.getCurrentContent();
			const selection = editorState.getSelection();
			const currentBlock = content.getBlockMap().get(selection.getFocusKey());
			const prevBlock = currentBlock && content.getBlockBefore(currentBlock.getKey());
			const nextBlock = currentBlock && content.getBlockAfter(currentBlock.getKey());
			switch(command) {
				// 如果上一个块是表格，将焦点定位到表格的最后一行
				case 'arrow-up': {
					if (prevBlock && tableComponentMap[prevBlock.getKey()]) {
						evt.preventDefault();
						// setSelectionToBlock(store, prevBlock, 'collapse');
						store.setEditorState(EditorState.set(
							editorState,
							{ selection: SelectionState.createEmpty(prevBlock.getKey()) }
						));
						tableComponentMap[prevBlock.getKey()].focusLastRow();
						return 'handled';
					}
					return 'not-handled';
				}
				// 如果下一个块是表格，将焦点定位到表格第一行
				case 'arrow-down': {
					if (nextBlock && tableComponentMap[nextBlock.getKey()]) {
						evt.preventDefault();
						// setSelectionToBlock(store, nextBlock, 'collapse');
						store.setEditorState(EditorState.set(
							editorState,
							{ selection: SelectionState.createEmpty(nextBlock.getKey()) }
						));
						tableComponentMap[nextBlock.getKey()].focusFirstRow();
						return 'handled';
					}
					return 'not-handled';
				}
				// 支持删除光标前面/后面的表格
				case 'delete':
				case 'backspace': {
					// 获得光标前后的表格，如果有，移除之
					const tableBlock = getDeletingTableBlock(editorState, command === 'delete');
					if (tableBlock) {
						removeBlock(store, tableBlock, command === 'delete' ? 'backward' : 'forward')
						return 'handled';
					}
					return 'not-handled';
				}
			}
			return 'not-handled';
		},

		getBlockRenderInfo(block, store, pluginAPI) {
			if (block.getType() === 'table') {
				const props = createTableBlockProps(block, store, pluginAPI, tableComponentMap);
				return {
					component: TableBlock,
					editable: false,
					props,
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/tablePlugin/createTablePlugin.js